export const RESUME = 'Resume';
export const REFERENCES = 'References';
export const CERTIFICATIONS = 'Certifications';
export const COVER_LETTER = 'Cover Letter';
export const PROFILE_PICTURE = 'Profile Picture';
export const PORTFOLIO = 'Portfolio';
export const OTHERS = 'Others';
